import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_SOCIALHEADER = 'ddc.link.socialHeaderClick';

function socialHeader({ currentTarget: element, timeStamp }) {
	let eventObject;

	if (
		!eventHasRun(DDC_LINK_SOCIALHEADER, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_LINK_SOCIALHEADER,
			eventData: {
				service: element.getAttribute('title'),
				url: element.getAttribute('href'),
				element
			}
		};
	}

	return eventObject;
}

export default socialHeader;
